import React from 'react'
import { supabase } from '@/lib/supabase'
import { defaultSignalsOverlayLevels, type SignalsOverlayLevels } from '../utils/signalsOverlayLevels'

const DEFAULT = defaultSignalsOverlayLevels()

export function useSignalsOverlayLevels(shouldLoad: boolean) {
  const [levels, setLevels] = React.useState<SignalsOverlayLevels>(DEFAULT)

  React.useEffect(() => {
    if (!shouldLoad) return
    let mounted = true

    ;(async () => {
      try {
        const { data, error } = await supabase.rpc('get_signals_overlay_levels')
        if (!mounted) return
        if (error) {
          console.error('get_signals_overlay_levels error', error)
          return
        }
        if (!data || typeof data !== 'object') return

        const next: SignalsOverlayLevels = {
          entryInitial: typeof (data as any).entryInitial === 'boolean' ? (data as any).entryInitial : true,
          entryMid: typeof (data as any).entryMid === 'boolean' ? (data as any).entryMid : true,
          entryFinal: typeof (data as any).entryFinal === 'boolean' ? (data as any).entryFinal : true,
          stop: typeof (data as any).stop === 'boolean' ? (data as any).stop : true,
          targets: typeof (data as any).targets === 'boolean' ? (data as any).targets : true,
        }

        setLevels(next)
      } catch (e) {
        console.error('get_signals_overlay_levels error', e)
      }
    })()

    return () => {
      mounted = false
    }
  }, [shouldLoad])

  return levels
}

